/** Detect Internet Explorer Browser */
export default function isIE(ua) {
	return /(MSIE|Trident)/.test(ua);
}
